import React from 'react';
import {
  IoFootball, IoFootballOutline, IoMap, IoMapOutline,
  IoAnalytics, IoAnalyticsOutline, IoHeart, IoHeartOutline,
  IoShield, IoShieldOutline, IoPerson, IoPersonOutline,
  IoMenu, IoNotificationsOutline, IoSearch, IoCloseCircle,
  IoArrowBack, IoRefresh, IoAdd, IoRemove, IoLocate,
  IoChevronBack, IoChevronForward, IoClose, IoLocationOutline,
  IoChatbubbles, IoNavigate, IoNavigateOutline, IoCloudOffline,
  IoAlertCircle, IoShareOutline, IoCalendarOutline, IoTimeOutline,
  IoTrophyOutline, IoFlagOutline, IoLeafOutline, IoSend,
  IoStar, IoStarOutline, IoPersonAdd, IoHome, IoAirplane,
  IoChevronDown, IoAddCircleOutline, IoCheckmarkCircle, IoCheckmark,
  IoChatbubbleOutline, IoLogOutOutline,
  IoMoonOutline, IoSunnyOutline,
  IoDocumentTextOutline,
  IoMicOutline,
  IoMic,
  IoEllipsisVertical,
  IoInformationCircle,
  IoOpenOutline,
  IoCopyOutline,
  IoLockClosedOutline,
} from 'react-icons/io5';
import type { IconType } from 'react-icons';

const iconMap: Record<string, IconType> = {
  'football': IoFootball,
  'football-outline': IoFootballOutline,
  'map': IoMap,
  'map-outline': IoMapOutline,
  'analytics': IoAnalytics,
  'analytics-outline': IoAnalyticsOutline,
  'heart': IoHeart,
  'heart-outline': IoHeartOutline,
  'shield': IoShield,
  'shield-outline': IoShieldOutline,
  'person': IoPerson,
  'person-outline': IoPersonOutline,
  'menu': IoMenu,
  'notifications-outline': IoNotificationsOutline,
  'search': IoSearch,
  'close-circle': IoCloseCircle,
  'arrow-back': IoArrowBack,
  'refresh': IoRefresh,
  'add': IoAdd,
  'remove': IoRemove,
  'locate': IoLocate,
  'chevron-back': IoChevronBack,
  'chevron-forward': IoChevronForward,
  'close': IoClose,
  'location-outline': IoLocationOutline,
  'chatbubbles': IoChatbubbles,
  'navigate': IoNavigate,
  'navigate-outline': IoNavigateOutline,
  'cloud-offline': IoCloudOffline,
  'alert-circle': IoAlertCircle,
  'share-outline': IoShareOutline,
  'calendar-outline': IoCalendarOutline,
  'time-outline': IoTimeOutline,
  'trophy-outline': IoTrophyOutline,
  'flag-outline': IoFlagOutline,
  'leaf-outline': IoLeafOutline,
  'send': IoSend,
  'star': IoStar,
  'star-outline': IoStarOutline,
  'person-add': IoPersonAdd,
  'home': IoHome,
  'airplane': IoAirplane,
  'chevron-down': IoChevronDown,
  'add-circle-outline': IoAddCircleOutline,
  'checkmark-circle': IoCheckmarkCircle,
  'checkmark': IoCheckmark,
  'chatbubble-outline': IoChatbubbleOutline,
  'log-out-outline': IoLogOutOutline,
  'moon-outline': IoMoonOutline,
  'sunny-outline': IoSunnyOutline,
  'document-outline': IoDocumentTextOutline,
  'mic-outline': IoMicOutline,
  'mic': IoMic,
  'ellipsis-vertical': IoEllipsisVertical,
  'information-circle': IoInformationCircle,
  'open-outline': IoOpenOutline,
  'copy-outline': IoCopyOutline,
  'lock-closed-outline': IoLockClosedOutline,
};

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

export function Icon({ name, size = 24, color, style }: IconProps) {
  const Component = iconMap[name];
  if (!Component) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  return <Component size={size} color={color} style={style} />;
}
